import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { ROUTES } from '@/constants/routes';

const Footer = styled.footer`
  display: grid;
  justify-items: center;
  padding: 8px 0;
  font-size: 12px;
  line-height: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

const Company = styled.div`
  color: #111827;
  font-weight: 500;
`;

const Links = styled.nav`
  display: flex;
  column-gap: 28px;
  row-gap: 8px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  a {
    color: #31bcf9;
    text-decoration: underline;
  }
`;

interface PaywallFooterProps {
  company?: string;
  privacyHref?: string;
  termsHref?: string;
  subscriptionHref?: string;
}

export function PaywallFooter({
  company = 'Alfamedia MF Ltd',
  privacyHref = ROUTES.POLICY.PRIVACY,
  termsHref = ROUTES.POLICY.TERMS,
  subscriptionHref = ROUTES.POLICY.SUBSCRIPTION,
}: PaywallFooterProps) {
  return (
    <Footer>
      <Company>{company}</Company>
      <Links>
        <Link to={privacyHref}>Privacy Policy</Link>
        <Link to={termsHref}>Terms of Use</Link>
        <Link to={subscriptionHref}>Subscription Information & Refund Policy</Link>
      </Links>
    </Footer>
  );
}
